// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Form__wrapper___1QcN8","h2":"Form__h2___3qdfA","form":"Form__form___MgMbk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ForgotPassword/Form.scss
// module id = HzEN
// module chunks = 0